"use strict";

exports.__esModule = true;
exports.StyledSliderHandle = exports.StyledSlider = exports.SliderHandleBar = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _rcSlider = _interopRequireDefault(require("rc-slider"));

require("rc-slider/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledSlider = (0, _styledComponents.default)(_rcSlider.default)`
    .rc-slider-rail {
        background-color: ${props => props.railColor ? props.railColor : props.theme.colors.slider.track};
    }
    .rc-slider-dot {
        background-color: ${props => props.dotColor ? props.dotColor : props.theme.colors.slider.dots.background};
        border: ${props => props.theme.space[3]} solid ${props => props.dotBorderColor ? props.dotBorderColor : props.theme.colors.slider.dots.border};
        width: ${props => props.theme.space[5]};
        height: ${props => props.theme.space[5]};
        top: -6px;
        margin-left: -${props => props.theme.space[4]};
    }
    .rc-slider-mark {
        top: -${props => props.handleSize};
        color: ${props => props.markColor ? props.markColor : props.theme.colors.slider.marks};

        .rc-slider-mark-text {
            color: ${props => props.markColor ? props.markColor : props.theme.colors.slider.marks};
        }
    }
`;
exports.StyledSlider = StyledSlider;

const getHandleOffset = ({
  handleSize
}) => {
  return `${parseInt(handleSize.replace(/\D/g, '')) / 2}px`;
};
/**
 * The slider handle has an invisible :before pseudo element to act as an overlay to prevent accidental text selection in the browser while dragging
 * It also has an invisible :after pseudo element to make the button larger and more usable on touch devices
 */


const StyledSliderHandle = _styledComponents.default.div`

    left: ${props => props.offset}%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.handleSize} !important;
    height: ${props => props.handleSize} !important;
    margin-top: -${props => getHandleOffset(props)} !important;
    margin-left: -${props => getHandleOffset(props)} !important;
    background-color: ${props => props.handleColor ? props.handleColor : props.theme.colors.slider.handle.background} !important;
    border-radius: 50%;
    border: none !important;
    box-shadow: none !important;
    z-index: 1;

    ${props => props.sliding && (0, _styledComponents.css)`
        &:before {
            content: "";
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: block;
            background-color: rgba(0,0,0,0.01);
        }
    `}


    @media (hover: none) and (pointer: coarse) {
        &:after {
            content: "";
            position: absolute;
            display: block;
            width: 60px;
            height: 60px;
            background-color: rgba(0,0,0,0.01);
            border-radius: 50%;
        }
    }
`;
exports.StyledSliderHandle = StyledSliderHandle;
const SliderHandleBar = _styledComponents.default.div`
    width: 0;
    border: 1px solid ${props => props.handleBarColor ? props.handleBarColor : props.theme.colors.slider.handle.bars};
    border-radius: 2px;
    margin: 0 ${props => props.theme.space[2]};
    height: 30%;
`;
exports.SliderHandleBar = SliderHandleBar;